var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 149,
    viewBox: "0 0 150 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.145 85.0736C124.382 83.8448 125 82.3898 125 80.7083V68.2917C125 66.6102 124.382 65.1552 123.145 63.9264C121.908 62.6977 120.443 62.0833 118.75 62.0833H87.5V31.0417C87.5 29.3602 86.8815 27.9052 85.6445 26.6764C84.4076 25.4477 82.9427 24.8333 81.25 24.8333H68.75C67.0573 24.8333 65.5924 25.4477 64.3555 26.6764C63.1185 27.9052 62.5 29.3602 62.5 31.0417V62.0833H31.25C29.5573 62.0833 28.0924 62.6977 26.8555 63.9264C25.6185 65.1552 25 66.6102 25 68.2917V80.7083C25 82.3898 25.6185 83.8448 26.8555 85.0736C28.0924 86.3023 29.5573 86.9167 31.25 86.9167H62.5V117.958C62.5 119.64 63.1185 121.095 64.3555 122.324C65.5924 123.552 67.0573 124.167 68.75 124.167H81.25C82.9427 124.167 84.4076 123.552 85.6445 122.324C86.8815 121.095 87.5 119.64 87.5 117.958V86.9167H118.75C120.443 86.9167 121.908 86.3023 123.145 85.0736ZM141.748 8.19694C147.249 13.6616 150 20.2418 150 27.9375V121.062C150 128.758 147.249 135.338 141.748 140.803C136.247 146.268 129.622 149 121.875 149H28.125C20.3776 149 13.7533 146.268 8.25195 140.803C2.75065 135.338 0 128.758 0 121.062V27.9375C0 20.2418 2.75065 13.6616 8.25195 8.19694C13.7533 2.73231 20.3776 0 28.125 0H121.875C129.622 0 136.247 2.73231 141.748 8.19694Z",
    fill: "#05164D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 149,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.33806440aa7d9e9d6a14958503384c15.svg";
export { ForwardRef as ReactComponent };